import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const ModelTest = () => {
  const [modal_grid, setmodal_grid] = useState(false);
  const [modal_sign, setmodal_sign] = useState(false);

  function tog_grid() {
    setmodal_grid(!modal_grid);
  }

  function tog_sign() {
    setmodal_sign(!modal_sign);
  }
  function showLogInModal()
  {
    setmodal_grid(true);
    setmodal_sign(false);
  }
  function showSignInModal()
  {
    setmodal_grid(false);
    setmodal_sign(true);
  }
  return (
    <div>
      <div>Welcome model test</div>
      <Button color="primary" onClick={() => setmodal_grid(true)}>
        Login
      </Button>
      <Button color="success" onClick={() => setmodal_sign(true)}>
        Sign In
      </Button>

      <Modal
        isOpen={modal_grid}
        toggle={() => {
          tog_grid();
        }}
      >
        <ModalHeader>
          <h5 className="modal-title">Grid Modals</h5>
          <Button
            type="button"
            onClick={() => {
              setmodal_grid(false);
            }}
            className="btn-close"
            aria-label="Close"
          ></Button>
        </ModalHeader>
        <ModalBody>
          Welcome to login
          <br />
          <Button color="success" onClick={() => setmodal_sign(true)}>
            Sign In
          </Button>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modal_sign}
        toggle={() => {
          tog_sign();
        }}
      >
        <ModalHeader>
          <h5 className="modal-title">Sign In Modal</h5>
          <Button
            type="button"
            onClick={() => {
              setmodal_sign(false);
            }}
            className="btn-close"
            aria-label="Close"
          ></Button>
        </ModalHeader>
        <ModalBody>
          Welcome to signin
          <br />
          <Button color="primary" onClick={() => setmodal_grid(true)}>
            Login
          </Button>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ModelTest;
